import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import styles from "../../../Styles/Modules/Paytable.module.scss";
import PaytableItem from "../PaytableItem/PaytableItem";

const Paytable = () => {
  const { t } = useTranslation();
  const { paytable } = useSelector((state) => state.game);

  return (
    <div className={styles.paytable}>
      <div className={styles.paytableHeader}>{t("symbols")}</div>

      <div className={styles.paytableContent}>
        {Object.entries(paytable).map(([key, values], index) => (
          <PaytableItem
            key={index}
            symbol={index + 1}
            paytableValues={values}
          />
        ))}
      </div>
    </div>
  );
};

export default Paytable;
